$(function () {

  function setMoreAccordion() {
    const $area = $(this);
    const $moreListItem = $('.review__content');
    const $moreButton = $('.review__other');

    if ($moreListItem.length <= 2) {
      $moreButton.hide();
      return;
    }

    $('.review__content:nth-of-type(n+3)').hide();

    $moreButton.on('click', function () {
      $moreListItem.fadeIn(200);
      $moreButton.hide();
    });
  }

  const isPageDetail = $('#detail').length;
  if (isPageDetail) {
    setMoreAccordion();
  }
});